import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import classnames from 'classnames';
import * as React from "react";
import icon from '../Icon/bar';
import "./index.css";

var ToolBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ToolBar, _React$PureComponent);

  var _super = _createSuper(ToolBar);

  function ToolBar() {
    _classCallCheck(this, ToolBar);

    return _super.apply(this, arguments);
  }

  _createClass(ToolBar, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          onClick = _this$props.onClick,
          toolbars = _this$props.toolbars,
          htmlProps = _objectWithoutProperties(_this$props, ["prefixCls", "className", "onClick", "toolbars"]);

      if (!toolbars || toolbars.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classnames("".concat(prefixCls, "-toolbar"), className)
      }, htmlProps), toolbars.map(function (name, key) {
        var Icon = icon[name];
        return /*#__PURE__*/React.createElement("button", {
          type: "button",
          key: key,
          onClick: onClick.bind(_this, name)
        }, " ", Icon, " ");
      }));
    }
  }]);

  return ToolBar;
}(React.PureComponent);

ToolBar.displayName = 'ToolBar';
ToolBar.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  prefixCls: 'md-editor',
  toolbars: ['bold', 'italic', 'header', 'strike', 'underline', 'olist', 'ulist', 'todo', 'link', 'image', 'quote']
};
export { ToolBar as default };